var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.911,
    height: 19.867,
    viewBox: "0 0 19.911 19.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy_icon",
    "data-name": "Copy icon",
    transform: "translate(-1093.5 -643.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4783",
    "data-name": "Path 4783",
    d: "M14.629,2.941v1.3H6.72A2.441,2.441,0,0,0,4.279,6.679v7.954H2.938A2.44,2.44,0,0,1,.5,12.191V2.941A2.44,2.44,0,0,1,2.938.5h9.25A2.441,2.441,0,0,1,14.629,2.941Z",
    transform: "translate(1094 644)",
    fill: "none",
    stroke: "#072531",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4784",
    "data-name": "Path 4784",
    d: "M24.833,13.031v9.25a2.438,2.438,0,0,1-2.441,2.438h-9.25A2.438,2.438,0,0,1,10.7,22.281v-9.25a2.441,2.441,0,0,1,2.441-2.441h9.25A2.441,2.441,0,0,1,24.833,13.031Z",
    transform: "translate(1087.578 637.648)",
    fill: "none",
    stroke: "#072531",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/Copy-Dark.c2486289d332b17a2a56791b65adc3bc.svg";
export { ForwardRef as ReactComponent };